/* eslint-disable */

export const customSearchLearningObjects = /* GraphQL */ `
  query SearchLearningObjects(
    $filter: SearchableLearningObjectFilterInput
    $sort: SearchableLearningObjectSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchLearningObjects(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        areaId
        areaNames
        course
        code
        type
        published
        contents {
          items {
            contentId
            content {
              id
              posterUrl
              title
              url
            }
            description
            id
            title
          }
          nextToken
        }
        sortedContentIds
      }
      nextToken
      total
    }
  }
`;